import React from 'react';
import Loadable from 'react-loadable';
import Loading from 'react-loading-animation';

const ComingSoonDialogLoadable = Loadable({
  loader: () => import('./ComingSoonDialog')
    .then(module => module.default)
    .catch(e => { console.log(e); if (window) window.location.reload(); }),
  loading: () => <div key="ComingSoonDialogLoadableLoading"><Loading /></div>
});

export default ComingSoonDialogLoadable;
